import {
  AfterViewInit,
  Component,
  DestroyRef,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { PaginatorModule } from 'primeng/paginator';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject } from 'rxjs';
import { AutoFocusService } from '@lx/quote-tool/lite/shared/services';
import { KeyboardFocusDirective } from '@lx/shared/ui/keyboard-focus';

@Component({
  standalone: true,
  selector: 'lx-searcher',
  templateUrl: './searcher.component.html',
  styleUrls: ['./searcher.component.scss'],
  imports: [InputTextModule, PaginatorModule, ReactiveFormsModule, KeyboardFocusDirective],
})
export class SearcherComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild('searchInput') searcherInputRef: ElementRef<HTMLInputElement> | undefined;

  @Input() queryReset = false;
  @Input() autofocus = false;
  @Output() searchTriggered = new EventEmitter<string>();

  searchControl = new FormControl('');

  private autofocus$ = new BehaviorSubject<boolean>(false);

  private readonly autoFocusService = inject(AutoFocusService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit() {
    // Emit search query
    this.searchControl.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => this.searchTriggered.emit((value ?? '').trim().toLowerCase()));
  }

  ngOnChanges({ queryReset, autofocus }: SimpleChanges): void {
    if (queryReset?.currentValue) {
      this.cleanQuery();
    }

    if (autofocus?.currentValue !== null && autofocus?.currentValue !== undefined) {
      this.autofocus$.next(autofocus.currentValue);
    }
  }

  ngAfterViewInit(): void {
    this.autoFocusService.focusWhenDesktop(this.autofocus$, () => this.searcherInputRef?.nativeElement);
  }

  private cleanQuery() {
    this.searchControl.reset();
  }
}
